__turbopack_context__.v({
  "container": "styles-module-scss-module__0J_eNW__container",
  "form": "styles-module-scss-module__0J_eNW__form",
  "header": "styles-module-scss-module__0J_eNW__header",
  "name": "styles-module-scss-module__0J_eNW__name",
  "submit": "styles-module-scss-module__0J_eNW__submit",
  "textBlock": "styles-module-scss-module__0J_eNW__textBlock",
});
